import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" No available options")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconsByImageCollection = _resolveComponent("IconsByImageCollection")!
  const _component_IconByImageLabeled = _resolveComponent("IconByImageLabeled")!
  const _component_IconByImage = _resolveComponent("IconByImage")!
  const _component_BasicSelectComponent = _resolveComponent("BasicSelectComponent")!

  return (_openBlock(), _createBlock(_component_BasicSelectComponent, {
    class: "mr-4",
    options: $setup.vouchersStore.getters.getItems,
    modelValue: $setup.localModel,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ($setup.localModel = $event))
  }, {
    "default-not-selected-option": _withCtx(() => [
      _createVNode(_component_IconByImageLabeled, {
        label: _ctx.$t('select.voucher')
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_IconsByImageCollection, { class: "is-collapsed is-medium mb-0" })
        ]),
        _: 1
      }, 8, ["label"])
    ]),
    option: _withCtx(({ option }) => [
      _createVNode(_component_IconByImageLabeled, {
        icon: option.ico,
        label: _ctx.$t(option.label)
      }, null, 8, ["icon", "label"])
    ]),
    "selected-option": _withCtx(({ option }) => [
      _createVNode(_component_IconByImageLabeled, {
        icon: option.ico,
        label: _ctx.$t(option.label)
      }, {
        icon: _withCtx(({ props }) => [
          (props.icon)
            ? (_openBlock(), _createBlock(_component_IconByImage, {
                key: 0,
                icon: props.icon
              }, null, 8, ["icon"]))
            : (_openBlock(), _createBlock(_component_IconsByImageCollection, {
                key: 1,
                class: "is-collapsed is-medium mb-0"
              }))
        ]),
        _: 2
      }, 1032, ["icon", "label"])
    ]),
    "no-options": _withCtx(({}) => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["options", "modelValue"]))
}